module.exports = __webpack_public_path__ + "img/footer-logo.e8ec2944.png";